import { useController } from 'react-hook-form'
import DropdownMenu from 'subapps/settings/components/DropdownMenu'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'

import { styles } from './styles'

const { Button } = Dropdown

const options = [
  {
    id: 'customer',
    value: 'customer',
    name: 'Customer changed/canceled order',
  },
  {
    id: 'fraud',
    value: 'fraud',
    name: 'Fraudulent order',
  },
  {
    id: 'inventory',
    value: 'inventory',
    name: 'Items unavailable',
  },
  {
    id: 'declined',
    value: 'declined',
    name: 'Payment declined',
  },
  {
    id: 'other',
    value: 'other',
    name: 'Other',
  },
]

const CancelReasonDropdown = ({ control, name }) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
    rules: { required: true },
    defaultValue: options && options[0].value,
  })
  const overlay = <DropdownMenu data={options} />
  const selected = options.find(item => item.value === value)
  return (
    <Dropdown
      overlay={overlay}
      onSelect={onChange}
      selectedKey={selected?.value}
    >
      <Button css={styles.dropdownBtn}>
        {selected ? selected.name : 'Please select cancellation reason'}
      </Button>
    </Dropdown>
  )
}

export default CancelReasonDropdown
